/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Arenas, ArenasInterface, ArenasConstructor } from "../Arenas";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "symbol",
            type: "string",
          },
          {
            internalType: "address[]",
            name: "operators",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "restricted",
            type: "address",
          },
          {
            internalType: "address",
            name: "methods",
            type: "address",
          },
          {
            internalType: "address",
            name: "payments",
            type: "address",
          },
          {
            internalType: "address",
            name: "alphadune",
            type: "address",
          },
          {
            internalType: "bytes4[][]",
            name: "targets",
            type: "bytes4[][]",
          },
          {
            internalType: "uint256",
            name: "alphadunePercentage",
            type: "uint256",
          },
        ],
        internalType: "struct ArenasConstructor.Struct",
        name: "input",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "token_uri",
            type: "string",
          },
          {
            internalType: "address",
            name: "platformAndArenaFeeCurrency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "platformAndArenaFee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "arenaMap",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "surface",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "distance",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "weather",
            type: "uint32",
          },
        ],
        indexed: false,
        internalType: "struct Arena.Struct",
        name: "arena",
        type: "tuple",
      },
    ],
    name: "EditArena",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "token_uri",
            type: "string",
          },
          {
            internalType: "address",
            name: "platformAndArenaFeeCurrency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "platformAndArenaFee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "arenaMap",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "surface",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "distance",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "weather",
            type: "uint32",
          },
        ],
        indexed: false,
        internalType: "struct Arena.Struct",
        name: "arena",
        type: "tuple",
      },
    ],
    name: "NewArena",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "arenaId",
        type: "uint256",
      },
    ],
    name: "arena",
    outputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "token_uri",
            type: "string",
          },
          {
            internalType: "address",
            name: "platformAndArenaFeeCurrency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "platformAndArenaFee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "arenaMap",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "surface",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "distance",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "weather",
            type: "uint32",
          },
        ],
        internalType: "struct Arena.Struct",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "arenaOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "arenas",
    outputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "token_uri",
        type: "string",
      },
      {
        internalType: "address",
        name: "platformAndArenaFeeCurrency",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "platformAndArenaFee",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "arenaMap",
        type: "uint256",
      },
      {
        internalType: "uint32",
        name: "surface",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "distance",
        type: "uint32",
      },
      {
        internalType: "uint32",
        name: "weather",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "control",
    outputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
      {
        internalType: "address",
        name: "restricted",
        type: "address",
      },
      {
        internalType: "address",
        name: "methods",
        type: "address",
      },
      {
        internalType: "address",
        name: "payments",
        type: "address",
      },
      {
        internalType: "address",
        name: "alphadune",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "alphadunePercentage",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "token_uri",
            type: "string",
          },
          {
            internalType: "address",
            name: "platformAndArenaFeeCurrency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "platformAndArenaFee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "arenaMap",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "surface",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "distance",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "weather",
            type: "uint32",
          },
        ],
        internalType: "struct Arena.Struct",
        name: "arena",
        type: "tuple",
      },
    ],
    name: "createArena",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "arenaId",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "token_uri",
            type: "string",
          },
          {
            internalType: "address",
            name: "platformAndArenaFeeCurrency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "platformAndArenaFee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "arenaMap",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "surface",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "distance",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "weather",
            type: "uint32",
          },
        ],
        internalType: "struct Arena.Struct",
        name: "arena",
        type: "tuple",
      },
    ],
    name: "editArena",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "arenaId",
        type: "uint256",
      },
    ],
    name: "handleArenaUsage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "id",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "arenaId",
        type: "uint256",
      },
    ],
    name: "platformAndArenaFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "arenaId",
        type: "uint256",
      },
    ],
    name: "platformAndArenaFeeCurrency",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "symbol",
            type: "string",
          },
          {
            internalType: "address[]",
            name: "operators",
            type: "address[]",
          },
          {
            internalType: "address",
            name: "restricted",
            type: "address",
          },
          {
            internalType: "address",
            name: "methods",
            type: "address",
          },
          {
            internalType: "address",
            name: "payments",
            type: "address",
          },
          {
            internalType: "address",
            name: "alphadune",
            type: "address",
          },
          {
            internalType: "bytes4[][]",
            name: "targets",
            type: "bytes4[][]",
          },
          {
            internalType: "uint256",
            name: "alphadunePercentage",
            type: "uint256",
          },
        ],
        internalType: "struct ArenasConstructor.Struct",
        name: "globalParameters",
        type: "tuple",
      },
    ],
    name: "setGlobalParameters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "whitelists",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type ArenasConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ArenasConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Arenas__factory extends ContractFactory {
  constructor(...args: ArenasConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "Arenas";
  }

  deploy(
    input: ArenasConstructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Arenas> {
    return super.deploy(input, overrides || {}) as Promise<Arenas>;
  }
  getDeployTransaction(
    input: ArenasConstructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(input, overrides || {});
  }
  attach(address: string): Arenas {
    return super.attach(address) as Arenas;
  }
  connect(signer: Signer): Arenas__factory {
    return super.connect(signer) as Arenas__factory;
  }
  static readonly contractName: "Arenas";
  public readonly contractName: "Arenas";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ArenasInterface {
    return new utils.Interface(_abi) as ArenasInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Arenas {
    return new Contract(address, _abi, signerOrProvider) as Arenas;
  }
}
